// extracted by mini-css-extract-plugin
module.exports = {"back-button":"Header_back-button__2KLwp","title":"Header_title__Q2PoW"};